<!--
    描述：角色列表
    时间：2020-04-22
    Created by zwh
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>角色列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="primary"
							   icon="el-icon-circle-plus"
							   v-if="roleBtns.includes('role_add')"
							   size="small"
							   @click="doClick('','add')">新增</el-button>
				</div>
			</div>

			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="menusContent">
						<el-table :data="treeData.tableData"
								  row-key="id"
								  v-loading="treeData.loading"
								  ref="menusTree"
								  default-expand-all
								  :height="treeData.tableH"
								  border
								  highlight-current-row
								  @row-click="rowClick"
								  :tree-props="{children: 'children'}">
							<el-table-column prop="roleName"
											 label="角色名称"
											 show-overflow-tooltip
											 min-width="130"></el-table-column>
							<el-table-column prop="roleTypeName"
											 label="角色类型"
											 show-overflow-tooltip
											 width="90"></el-table-column>
							<el-table-column label="操作"
											 align="center"
											 show-overflow-tooltip
											 width="110">
								<template slot-scope="scope">
								    <!--
									<el-button size="mini"
											   icon="el-icon-circle-plus"
											   title="新增"
                                               v-if="roleBtns.includes('role_add')"
											   type="text"
											   @click="doClick(scope.row,'add')"></el-button>
									-->
									<el-button size="mini"
											   icon="el-icon-edit"
											   title="编辑"
                                               v-if="roleBtns.includes('role_edit')"
											   type="text"
											   @click="doClick(scope.row,'edit')"></el-button>
									<el-button v-if="!scope.row.children && roleBtns.includes('role_delete')"
											   size="mini"
											   icon="el-icon-delete"
											   title="删除"
											   type="text"
											   @click="doClick(scope.row,'delete')"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 弹窗组件 -->
			<addRole ref="addMenu"
					 v-if="dialogObj.visible"
					 :mode="dialogObj.mode"
					 :transObj="transObj"
					 @handle-success="handleSuccess"></addRole>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import addRole from './add_role_dialog'
import { selectAll, deleteById, selectTree } from 'api/system/role.js'
import { getLimitRoleByLimitId } from 'api/system/limitRole.js'
export default {
	components: { addRole },
	data() {
		return {
			transObj: {
				id: '',
				parentId: '',
				parentName: '',
				type: ''
			},

			btnLoading: false,
			dialogObj: {
				title: '',
				visible: false,
				width: '650px',
				mode: 'add'
			},
			treeData: {
				loading: false,
				tableH: 200,
				tableData: []
			}
		}
	},
	methods: {
		getMenuTreeTableData() {
			let that = this

			let param = {}
			param.limitId = ''//
			selectTree(param).then(res => {
				if (res.operationCode == 1) {
					that.treeData.tableData = res.data
					//that.getLimitRoleByLimitId(res.data)
				}
			})
		},
		getLimitRoleByLimitId(dataTree){
		    let that = this
		    let limitId = ''//
            if(limitId == '') {
                that.treeData.tableData = dataTree
                return
            }

            let param = {
                limitId : limitId
            }
            getLimitRoleByLimitId(param).then(res => {
                if (res.operationCode == 1) {
                    let limitRoleIdList = res.data.limitRoleIdList

                    //系统角色
                    let sysRoleTree = dataTree.filter(item=> {return item.limitId == null})
                    //个体角色
                    let userRoleTree = dataTree.filter(item=> {return item.limitId != null})

                    let sysDataArr = that.$utils.toTreeArray(sysRoleTree)
                    sysDataArr = sysDataArr.filter(item=> {return limitRoleIdList.includes(item.id)})
                    let sysDataTree = that.$utils.toArrayTree(sysDataArr)

                    that.treeData.tableData = that.$utils.toArrayTree(sysDataTree.concat(userRoleTree))

                    /*
                    let dataArr = that.$utils.toTreeArray(dataTree)
                    dataArr = dataArr.filter(item=> {return limitRoleIdList.includes(item.id)})
                    that.treeData.tableData = that.$utils.toArrayTree(dataArr)
                    */
                }
            });
		},

		//新增、修改、删除等操作按钮点击事件
		doClick(obj, type) {
			let that = this
			that.dialogObj.mode = type
			if (type === 'add') {
				this.transObj.id = ''
				if (obj != '') {
					that.transObj.type = 'addSon'
					this.transObj.parentId = obj.id
					this.transObj.parentName = obj.roleName
				} else {
					that.transObj.type = 'addParent'
					this.transObj.parentId = '0'
					this.transObj.parentName = ''
				}
				this.dialogObj.title = '新增角色'
				this.dialogObj.visible = true
			} else if (type === 'edit') {
				that.transObj.type = 'edit'
				this.transObj.id = obj.id
				this.transObj.parentId = ''
				this.transObj.parentName = ''
				this.dialogObj.title = '编辑角色'
				this.dialogObj.visible = true
			} else if (type === 'delete') {
				this.delete(obj)
			}
		},
		delete(obj) {
			let that = this
			this.$confirm(
				'删除角色信息，将会删除角色菜单、角色菜单按钮、权限数据等信息，确认删除吗?',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}
			).then(() => {
				let param = {
					id: obj.id
				}
				deleteById(param).then(res => {
					if (res.operationCode == 1) {
						that.$message({ message: '删除成功', type: 'success' })
						that.getMenuTreeTableData()

						let obj = {
							id: '',
							roleName: ''
						}
						this.$emit('row-click', obj)
					} else {
						that.$message({ message: res.msg, type: 'error' })
					}
				})
			})
		},
		rowClick(obj) {
			this.$emit('row-click', obj)
		},
		// 关闭弹窗事件
		handleClose() {},
		// 确定按钮事件
		doSave() {
			this.$refs.addMenu.doSave()
		},

		//新增/编辑菜单成功
		handleSuccess() {
			this.dialogObj.visible = false
			this.getMenuTreeTableData()
		}
	},
	created() {
		this.getMenuTreeTableData()
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.treeData.tableH = this.$refs.menusContent.offsetHeight
			}, 100)
		})
	},
	// 缓存页面进入时
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.treeData.tableH = this.$refs.menusContent.offsetHeight
			}, 100)
		})
	},
	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	watch: {
		clientSize(val) {
			this.treeData.tableH = this.$refs.menusContent.offsetHeight
		}
	}
}
</script>
<style lang="less" scoped>
.w-table-page {
	padding-bottom: 5px;
}
</style>
